import { put } from 'helpers/api';

export const setListingGuid = (listingId: number, guid: string | null) => {
  return put(`/listings/${listingId}/update_anywhere_re_listing_id`, { listing: { anywhere_re_listing_id: guid } });
};
